<table>
  <tr>
    <th>{{ 'dashboard.assignments.client' | translate }}</th>
    <th>{{ 'dashboard.assignments.role' | translate }}</th>
    <th>{{ 'dashboard.assignments.ends' | translate }}</th>
    <!-- Named month, not "This month": these hours are always the current calendar
         month, never the period the dashboard is showing. -->
    <th class="num">{{ data?.monthStart ? (data.monthStart | date: 'LLLL') : ('dashboard.assignments.month' | translate) }}</th>
  </tr>
  <tr *ngFor="let row of data?.rows">
    <td [title]="row.client"><b>{{ row.client }}</b></td>
    <td [title]="row.role">{{ row.role }}</td>
    <td>{{ row.endsOn ? (row.endsOn | date: 'd MMM y') : '—' }}</td>
    <td class="num">{{ row.hoursThisMonth }} {{ 'dashboard.unit.hours_suffix' | translate }}
      <span class="tag" [class.internal]="row.internal">{{ (row.internal ? 'dashboard.assignments.internal' : 'dashboard.assignments.running') | translate }}</span></td>
  </tr>
</table>
